import { render, staticRenderFns } from "./footer-link-lists.vue?vue&type=template&id=14e92219&"
import script from "./footer-link-lists.vue?vue&type=script&lang=js&"
export * from "./footer-link-lists.vue?vue&type=script&lang=js&"
import style0 from "./footer-link-lists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports